import React from "react";
import classes from "./classes.module.scss";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import CloseIcon from "@Assets/Icons/cross.svg";
import Image from "next/image";
import ToastHandler from "@Front/Components/DesignSystem/Toasts/ToastsHandler";
import { Toasts, IToast } from "@Front/Stores/Toasts";
import Check from "@Front/Components/Elements/Icons/Check";
import NotifEmptyIcon from "@Assets/Icons/notif-empty.svg";
type IProps = {
	isOpen: boolean;
	closeModal: () => void;
};
type IState = {
	toastList: IToast[] | null;
};

export default class NotificationModal extends React.Component<IProps, IState> {
	private removeOnToastChange?: () => void;

	constructor(props: IProps) {
		super(props);
		this.state = {
			toastList: Toasts.getInstance().toasts,
		};
		this.handleToastChange = this.handleToastChange.bind(this);
		this.readAllNotifications = this.readAllNotifications.bind(this);
	}

	public override render(): React.JSX.Element | null {
		if (!this.props.isOpen) return null;
		return (
			<div className={classes["root"]} data-testid="header-openable-panel" data-openable="notifications">
				{this.renderHeader()}
				{this.renderMarkAllRead()}
				<div className={classes["notification-body"]}>{this.renderBody()}</div>
			</div>
		);
	}

	private renderHeader(): React.JSX.Element {
		return (
			<div className={classes["notification-header"]}>
				<Typography typo={ETypo.TEXT_MD_SEMIBOLD}>Notifications</Typography>
				<button
					type="button"
					className={classes["close-button"]}
					onClick={this.props.closeModal}
					aria-label="Close notification modal">
					<Image src={CloseIcon} alt="" className={classes["close-icon"]} />
				</button>
			</div>
		);
	}

	private renderMarkAllRead(): React.JSX.Element {
		return (
			<button type="button" className={classes["notification-subheader"]} onClick={this.readAllNotifications}>
				<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.COLOR_SECONDARY_500}>
					Tout marquer comme lu
				</Typography>
				<Check color={ETypoColor.COLOR_SECONDARY_500} />
			</button>
		);
	}

	private renderBody(): React.JSX.Element {
		if (!this.state.toastList || this.state.toastList.length === 0) {
			return (
				<div className={classes["missing-notification"]}>
					<Image src={NotifEmptyIcon} alt="Notif Empty" className={classes["notif-icon"]} />
					<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.COLOR_NEUTRAL_700}>
						Vous n&apos;avez pas de notifications.
					</Typography>
				</div>
			);
		}
		return <ToastHandler />;
	}

	public override componentDidMount(): void {
		this.removeOnToastChange = Toasts.getInstance().onChange(this.handleToastChange);
	}

	public override componentWillUnmount(): void {
		this.removeOnToastChange?.();
	}

	private readAllNotifications(): void {
		Toasts.getInstance().closeAll();
		this.props.closeModal();
	}

	private handleToastChange(toastList: IToast[] | null): void {
		this.setState({
			toastList,
		});
	}
}
